/** @file checkPuppet: validates the draft's puppet after a command, with paths under `/puppet`. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { validatePuppet } from '@zilo/pose3d-format/validate/validatePuppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import { toPose3DError } from '@zilo/pose3d-std/errors/toPose3DError';
import type { CommandContext } from '../context/commandContext';
import { withPathPrefix } from '../validate/withPathPrefix';
import type { PuppetDoc } from './puppetDoc';

/** The hint of a SHEET_UNKNOWN: the sheets there are and the commands that make one (CR-010). */
const sheetHint = (draft: PuppetDoc): string => {
  const names = Object.keys(draft.puppet.sheets);
  return `sheets: ${names.length === 0 ? 'none yet' : names.join(', ')}; drawable.add creates a sheet it names, sheet.upload fills one`;
};

/** Throws the first error of `draft.puppet` (rolling the batch back); profiles come from the context. */
export function checkPuppet(draft: PuppetDoc, ctx: Pick<CommandContext, 'profiles'>): void {
  try {
    withPathPrefix('/puppet', () => validatePuppet(draft.puppet, { profiles: ctx.profiles }));
  } catch (e) {
    const err = toPose3DError(e);
    if (err?.code !== ERROR_CODES.SHEET_UNKNOWN) throw e;
    throwError(err.code, { ...err.params }, { ...(err.path === undefined ? {} : { path: err.path }), hint: sheetHint(draft) });
  }
}
